/* eslint-disable max-len */

export const page = {
    error: {
        browser_incompatible:
            'It appears that you are currently using an outdated version of your browser. To ensure optimal security, we strongly advise updating your browser to benefit from the latest security enhancements.',
        safari_browser_incompatible:
            'The browser and/or browser version you’re running is known to cause issues with our platform due to a defect which was fixed in later versions of Safari. We recommend that you update your browser to a more recent version, or use an alternative such as Chrome, Firefox or Edge.'
    },
    reports: {
        heading: 'Reports',
        adviser_documents_activity_description:
            'This report provides details of actions taken on documents in the platform library related to your organisation.',
        adviser_marketing_activity_description:
            'This report provides details of browsing activity on the platform carried out by users in your organisation. This includes viewing and updating items like offers, shortlists and proposals.',
        adviser_security_activity_description:
            'This report provides details of security events related to users in your organisation. These include logins, password resets and key account changes.',
        investor_documents_activity_description:
            'This report provides details of actions taken on documents in the platform library associated with your clients.',
        investor_flow_activity_description: 'This report provides step-by-step information on the proposal workflow.',
        investor_marketing_activity_description:
            'This report provides details of browsing activity on the platform carried out by your clients. This includes viewing and updating items like offers, shortlists and proposals.',
        investor_security_activity_description:
            'This report provides details of security events related to your clients. These include logins, password resets and key account changes',
        pending_applications: {
            alert_text:
                "This report shows investors which have applied for an investment account, but have no 'Investment account authorised' date set. Once the authorised date is set, the account will drop off this report."
        },
        tax_year: {
            alert_text:
                'Tax relief amounts calculated by this report are based on the maximum tax relief available for the investments and does not take into account the personal circumstances of the investor. The tax status of each investment is taken as reported. Future actions either by the investor or by the investee company may affect the tax status and tax relief which can be claimed.'
        }
    },
    settings: {
        profile: {
            personal_details_heading: 'Personal Details',
            nationality_heading: 'Nationality and Domicile',
            investor_status_heading: 'Investor Status',
            regulatory_details_heading: 'Regulatory Details',
            contact_details_heading: 'Contact Details'
        },
        firm_information: {
            advanced_to_basic_visibility_groups_title: 'Switch to Basic Visibility Groups?',
            advanced_to_basic_visibility_groups_text:
                'Moving from Advanced to Basic Visibility Groups permanently removes all parent and child relationships between visibility groups. This change will not take effect until you save your changes.',
            advanced_to_basic_visibility_groups_keep_advanced: 'Keep Advanced',
            advanced_to_basic_visibility_groups_switch_basic: 'Switch to Basic'
        },
        bank_accounts: {
            authorised_with_no_bank_account_notice:
                'No bank account details were provided during the application process. You will not be able to withdraw any funds from your account until your bank details have been provided and verified.',
            authorised_with_no_bank_account_notice_title:
                'Important Notice: Bank Account Details Required for Fund Withdrawal',
            not_authorised_with_no_bank_account_notice: 'Only the account owner can manage their bank accounts.',
            deferral_checkbox_label:
                'I would like to open my GrowthInvest account without a linked bank account, and I understand that I will need to add this at a later stage.',
            james_brearley_account_name: 'James Brearley & Sons Ltd',
            james_brearley_account_number: '10 49 16 89',
            james_brearley_address:
                'Online Services Team (GrowthInvest), James Brearley & Sons, Walpole House, Unit 2 Burton Road, Blackpool, FY4 4NW',
            james_brearley_address_label:
                'Cheques should be made payable to "James Brearley & Sons Ltd" and sent to the following address with a cover letter stating your name and client number.',
            james_brearley_bank_name: 'Royal Bank of Scotland',
            james_brearley_description:
                'This account is to be used for making investment in any listed products. This may include VCT & AIM products and ISA transfers only. You must use your James Brearley Client Number followed by your surname as payment reference for Online Bank Transfers to ensure funds are allocated correctly. If you do not, this will cause unnecessary delays in cash allocation.',
            james_brearley_description_warning:
                'If you do not know your James Brearley Client Number (N.B. this is different from your GrowthInvest Client reference and account numbers), please ask your intermediary or email clientservices@growthinvest.com before making payment',
            james_brearley_heading: 'James Brearley GrowthInvest Bank Account Details',
            james_brearley_sort_code: '16 14 12',
            subtitle:
                'Please provide details of the bank account to which any distributions, for example dividends, should be paid. This should usually be in the name of the bank account holder. Please note that additional verification checks may be required, including a copy of a bank statement to confirm details in advance of the transfer of any funds.',
            transfer_details_title: 'Transfer funds to your GrowthInvest account',
            woodside_account_name: 'WCSL GrowthInvest Client Account',
            woodside_account_number: '10 40 96 65',
            woodside_address:
                "GrowthInvest Team, Woodside Corporate Services Ltd, 1st Floor, 12-14 Mason's Avenue, London, EC2V 5BT",
            woodside_address_label:
                'Cheques should be made payable to "WCSL GrowthInvest Client Account" and sent to the following address:',
            woodside_bank_name: 'Bank of Scotland',
            woodside_description:
                'This account is to be used when making an investment in any unlisted (SEIS, EIS, IHT/BR excl. AIM) and private equity products only. Any money deposited will be shown as a cash balance on your account. To ensure funds are allocated correctly and in a timely manner, please use the reference stated below when making online payments.',
            woodside_heading: 'Woodside GrowthInvest Bank Account Details',
            woodside_sort_code: '80 20 00',
            transaction_reference_description: 'You must use a reference number when transferring funds.',
            transaction_reference_prefix: 'Your reference for this account is:'
        },
        billing: {
            auto_payments_description:
                'Automatic payments are used to periodically withdraw excess cash and to settle fees and charges.',
            fee_documents_description:
                'These documents, provided by your adviser, offer detailed information to help you understand the fees and charges associated with the services they deliver.',
            fee_documents_empty: 'There are currently no documents available to download, please come back later.',
            gi_fee_description:
                'An annual fee is applied as a percentage of your overall portfolio value. The standard charge is 0.25% per annum, with a minimum annual charge of £250. Any agreed variation to the current standard terms will be detailed on the GrowthInvest Fees and Charges document.',
            intermediary_fee_description:
                'GrowthInvest can facilitate the payment of fees to your adviser or financial intermediary if requested. Please EITHER select Option A, and enter a % or a £ amount for adviser fees to be applied OR Select Option B, and check the box below to indicate that any adviser fees and charges have been agreed in advance. To change these fees please contact our Client Services team.',
            intermediary_fee_short_description:
                'Please EITHER select Option A, and enter a % or a £ amount for adviser fees to be applied OR Select Option B, and check the box below to indicate that any adviser fees and charges have been agreed in advance.',
            subtitle:
                'Please review all fees and charges detailed below. All the latest GrowthInvest account and administration charges are available on the Fees and charges document.'
        },
        branding: {
            avatar: 'Also known as the "Profile Picture", your brand avatar is a smaller version of your brand logo that represents your brand on the platform. It is typically displayed alongside your brand name and serves as a visual identifier for you organisation.',
            background:
                "The background image should be a high-quality JPG file that captures the essence of the company's brand identity. It should be visually appealing and non-distracting, ensuring that it does not interfere with the client self-registration process.",
            pdf_cover:
                'The PDF cover image should be a high-quality JPG file. The cover image will be displayed on the first page of both the portrait and landscape PDF exports from the platform. The images you upload must be A4 size (21cm x 29.7cm) or have a ratio of 1:1.41 to prevent distortion.',
            colours:
                'The colours you choose should be consistent with your brand and should pass the recommended contrast accessibility test to ensure that people with moderately low vision can use the platform.',
            favicon:
                "The favicon appears in the web browser's address bar, next to the page title, and on bookmarks or tabs. The purpose of the favicon is to provide a visual representation of the platform in the browser's interface, making it easier for users to identify.",
            logo: "Before you update your platform logo, it's important to consider the impact this change may have on your brand identity and recognition. Your logo is often the first thing that clients see so it's essential to ensure it's either a high-quality transparent PNG or an SVG.",
            preview:
                'The preview will help to get a feel for what it will look like when you apply the changes to the platform branding.'
        },
        communication: {
            growthinvest_marketing_updates_tooltip:
                'Clients and users can opt in to receiving direct GrowthInvest updates on relevant product information, and newsletters about the company aimed at our clients',
            growthinvest_technical_regulatory_updates_tooltip:
                'This is a mandatory selection for all users, and is used only for required communications'
        },
        external_users: {
            heading: 'External Users'
        },
        users: {
            heading: 'Users'
        },
        users_visibility_groups_bulk: {
            primary_contacts_modal_title: 'Manage primary contact groups',
            primary_contacts_modal_description:
                'Select every visibility group for which {name} should be a primary contact.',
            grants_modal_title: 'Manage viewer groups',
            grants_modal_description: 'Select every visibility group for which {name} should be a viewer.',
            save_error: 'Could not save visibility group assignments. Please try again.'
        },
        visibility_groups: {
            restrictions_off_title: 'Visibility Restrictions are DISABLED',
            restrictions_off_text:
                'Clients are visible to all users. Enable visibility restrictions to restrict client visibility to primary contact and visibility group viewers only.',
            restrictions_on_title: 'Visibility Restrictions are ENABLED',
            restrictions_on_text:
                'Users in your firm will only see investors they are the primary contact for, unless you grant them access to view additional visibility groups. Disable visibility restrictions to allow users in your firm to see all investors.',
            disable_title: 'Disable Visibility Restrictions',
            disable_text: 'This change will remove all visibility restrictions from users in your firm.',
            enable_title: 'Enable Visibility Restrictions',
            enable_text: 'This change will restrict the visibility of users in your firm.',
            enable_affected_users_warning: 'will have visibility restrictions applied.',
            disable_affected_users_warning:
                'will have unrestricted visibility of all investors (including those they are not the primary contact for).',
            enablement_disabled_tooltip: 'You can activate/deactivate {visibility_group} when it has been named.',
            primary_contacts_title: 'Primary Contacts',
            primary_contacts_description: 'Users who are the primary contacts for investors in {visibility_group}.',
            primary_contacts_empty_text: 'No primary contacts have been selected for {visibility_group}.',
            primary_contacts_empty_button: 'Select primary contacts',
            primary_contacts_modal_title: 'Select Primary Contacts',
            primary_contacts_modal_description:
                'Select the users who are primary contacts for investors in {visibility_group}.',
            primary_contacts_save_error: 'Failed to save primary contacts.',
            grants_title: 'Who can view this Visibility Group',
            grants_description: 'Users who have been granted visibility of the investors in {visibility_group}.',
            grants_empty_text: 'No users have been granted visibility of {visibility_group}.',
            grants_empty_button: 'Select viewers',
            grants_modal_title: 'Select Viewers',
            grants_modal_description:
                'Select the users who should be granted visibility of the investors in {visibility_group}.',
            grants_save_error: 'Failed to save viewers.',
            relationships_title: 'Relationships',
            relationships_description: 'Which visibility groups are also included in {visibility_group}?',
            children_empty_text: 'No child visibility groups have been added to {visibility_group}.',
            children_empty_max_depth_text:
                'This group is at the lowest hierarchy level. Child visibility groups are not available.',
            children_empty_button: 'Select child visibility groups',
            relationships_modal_title: 'Select child visibility groups',
            relationships_modal_helper:
                'Choose direct child visibility groups for {visibility_group}. Each group can only have one parent and cannot be assigned to itself or an ancestor. Assigning a group here removes it from any other parent.',
            relationships_modal_available: 'Available',
            relationships_modal_selected: 'Selected',
            relationships_modal_empty_selected: 'No child visibility groups selected.',
            relationships_modal_none_available: 'No other visibility groups can be added here.',
            relationships_modal_no_search_results: 'No visibility groups match your search.',
            relationships_modal_add_child: 'Add {name} as a child',
            relationships_modal_remove_child: 'Remove {name} from children',
            relationships_save_error: 'Failed to save visibility group relationships.',
            relationships_cycle_error:
                'This change would create a cycle in the visibility group hierarchy. Remove descendant selections and try again.',
            relationships_max_depth_error:
                'This change would exceed the maximum of {max_depth} hierarchy levels. Remove child visibility groups from the selection or shorten the branch you are moving before trying again.',
            relationships_max_depth_tooltip:
                'This visibility group cannot be added as a child here because it would exceed the maximum of {max_depth} hierarchy levels. Remove its child groups first, or reparent in smaller steps.',
            map_title: 'Hierarchy',
            map_description: 'Visual hierarchy of inheritance for {visibility_group}.',
            map_description_overview: 'Visual hierarchy of inheritance across all visibility groups.',
            map_fullscreen: 'View hierarchy in fullscreen',
            map_close_fullscreen: 'Close fullscreen view',
            map_recentre: 'Re-centre',
            no_items: 'No items',
            no_visibility_group_selected: 'Select a visibility group from the list to view its details.',
            no_visibility_group_available:
                'Restrict the visibility of users in {organisation} to investors derived from primary contacts in the visibility groups they have been granted access to view. Get started by creating a visibility group.',
            empty_items_text: 'No visibility groups found.',
            active_with_enabled_visibility_restrictions: 'Visibility Group is active',
            active_with_disabled_visibility_restrictions:
                'Visibility Group is active - Restrictions will apply when Visibility Restrictions are enabled',
            inactive: 'Visibility Group is inactive',
            deletion_disabled_tooltip: 'You can delete {visibility_group} when it is deactivated.',
            deletion_has_children_tooltip:
                'You cannot delete {visibility_group} whilst it has child visibility groups. Remove child relationships first.',
            deletion_tooltip: 'Delete {visibility_group}.',
            delete_title: 'Delete Visibility Group',
            delete_text: 'This action will permanently delete {visibility_group}.',
            delete_affected_users_warning: 'will lose visibility of investors from this visibility group.',
            delete_error: 'Failed to delete visibility group.',
            delete_requires_uncouple_children_error:
                'You cannot delete {visibility_group} whilst it has child visibility groups. Remove child relationships first, then try again.',
            discard_draft_tooltip: 'Discard this unsaved visibility group.',
            new_visibility_group_for: 'New visibility group for {organisation}',
            create_requires_name: 'You must enter a name before creating a visibility group.',
            create_error: 'Failed to create visibility group.',
            export_as_xlsx: 'Download full audit report in XLSX format',
            export_as_pdf: 'Download full audit report in PDF format',
            export_error: 'Failed to export visibility groups audit report.'
        },
        restricted_panels: {
            offers_title: 'Offers',
            offers_description: 'Offers available in {panel}.',
            offers_empty_text: 'No offers have been added to {panel}.',
            offers_load_error: 'We could not load offers right now. Please try again.',
            offer_type: {
                FUND: 'Fund',
                SINGLE_COMPANY: 'Single Company'
            },
            delete_title: 'Delete Panel',
            delete_text: 'This action will permanently delete {panel}.',
            deletion_disabled_tooltip: 'Default panel cannot be deleted.',
            deletion_tooltip: 'Delete {panel}.',
            new_panel_for: 'New panel for {organisation}',
            create_requires_offer: 'You must select at least one offer before creating a panel.',
            select_offers_title: 'Select Offers',
            select_offers_description: 'Choose the offers for {panel}.',
            no_panel_available:
                'Restricted panels control which offers are available to users in {organisation}. Get started by creating a panel.',
            save_error: 'Failed to save panel offers.'
        },
        financial: {
            fees_charges_title: 'Fees and Charges',
            fees_charges_subtitle: 'Last 12 months of fees and charges statements.'
        }
    },
    transaction_action: {
        CHANGE_AMOUNTS_AND_SHARES: {
            PURCHASE:
                'Update the amounts for this purchase. Note that this will update the initial investment amounts on the holding.',
            SALE: 'Update the amounts for this sale. The holding disposition status will be updated to reflect the number of shares sold in this transaction and will be opened/closed accordingly. Note that if future sales close this position, the number of shares you can sell will be limited by those transactions. If necessary, delete them first.'
        },
        CHANGE_FUND_AMOUNT:
            'Enter a new initial investment amount for this fund investment. This will update the tranche and the transactions to match.',
        CHANGE_PRODUCT:
            'Select a new product for this transaction. This will update the holding and all related transactions (e.g. any related sell or dividend transactions).',
        CHANGE_SALE_AMOUNT: 'Update the amount of this transaction.',
        DELETE_TRANSACTION: {
            relationship_warning:
                'Deleting this transaction will remove all transactions, holdings and, where appropriate, tranches related to this transaction. This potentially has a wide-ranging effect and you should proceed with EXTREME CAUTION.',
            warning:
                'Deleting this transaction will remove all trace of this transaction ever having existed in the system. This should only be used when a transaction has been entered in error.'
        },
        TOGGLE_ON_OFF_PLATFORM: {
            OTHER: 'Change the on/off platform status.',
            PURCHASE:
                'Change the on/off platform status. Note that this will update the position to reflect the correct platform status.'
        }
    },
    remote_application_action: {
        DELETE_REMOTE_APPLICATION: {
            warning:
                'Deleting this remote application will remove all trace of this application ever having existed in the system. This should only be used when an application has been entered in error.'
        }
    },
    bulk_share_allotment: {
        heading: 'Bulk Share Allotment',
        description:
            'Allot shares to multiple holdings at once. Start by selecting the product you wish to allot shares for.',
        SELECT_HOLDINGS: {
            heading: 'Select Holdings',
            description: 'Select the holdings you wish to allot shares to.'
        },
        PREPARE_HOLDINGS: {
            heading: 'Prepare Holdings',
            description:
                'Review the holdings you have selected and enter the number of shares you wish to allot to each holding.'
        }
    },
    dri_management: {
        heading: 'DRI Management',
        description: 'Manage dividend reinvestment plans.'
    },
    proposal: {
        special_event: {
            PROPOSAL_APPLICATION_SIGNED: {
                title: 'Proposal Application Signed',
                description: 'Provide the date when the application was signed:'
            },
            PROPOSAL_FUNDS_TRANSFERRED: {
                title: 'Funds Transferred',
                description: 'Provide the date when the funds were transferred:'
            }
        }
    },
    proposals: {
        heading: 'Proposals',
        description: 'Proposals are a way to keep track of potential investments.'
    },
    shortlists: {
        heading: 'Shortlists',
        description: 'Shortlists are a way to keep track of investments that you are interested in.'
    },
    portfolio_dashboard: {
        heading: 'Dashboard',
        description: 'View a summary of your portfolio.'
    },
    portfolio_detail: {
        heading: 'Portfolio Detail',
        summary: {
            heading: 'Summary',
            description: 'View a summary of your portfolio.'
        },
        single_company: {
            heading: 'Single Company',
            description: 'View Single Company investments in your portfolio.'
        },
        eis_seis: {
            heading: 'EIS and SEIS Funds',
            description: 'View EIS and SEIS fund investments in your portfolio.'
        },
        vct: {
            heading: 'Venture Capital Trusts',
            description: 'View Venture Capital Trust investments in your portfolio.'
        },
        iht: {
            heading: 'IHT and Estate Planning',
            description: 'View IHT and Estate Planning Services investments in your portfolio.'
        },
        pmi_closed_stable: {
            heading: 'Private Market',
            description: 'View Private Market investments in your portfolio.'
        },
        pmi_closed: {
            heading: 'Private Market (Closed-ended)',
            description: 'View Private Market investments in your portfolio.'
        },
        pmi_open: {
            heading: 'Private Market (Open-ended/Other)',
            description: 'View Private Market investments in your portfolio.'
        }
    },
    client_registrations: {
        heading: 'Client Registrations',
        description: 'View a list of client registrations.'
    },
    clients: {
        heading: 'Clients',
        description: 'View a list of clients.'
    },
    transactions: {
        heading: 'Transactions',
        description: 'View a list of transactions.'
    },
    library: {
        heading: 'Library',
        description: 'View a list of documents.'
    },
    investor_portfolio_restricted: {
        heading: 'This page will be available soon',
        investor_notice:
            'Our Asset Servicing team are currently working to update your account. During this time, you may see changes to investment values, cash balances and, if applicable, additional assets being onboarded. If you have any queries, please contact our team.',
        adviser_notice:
            "Our Asset Servicing team are currently working to update your client's account. During this time, you may see changes to investment values, cash balances and, if applicable, additional assets being onboarded. If you have any queries, please contact our team."
    },
    investor_visibility_panel: {
        heading_on: 'Who can see this investor',
        description_on:
            'Users listed here are able to view the profile and investment data for {name} on the platform.',
        heading_off: 'Who would be able to see this investor',
        description_off:
            'Users listed here will be able to view the profile and investment data for {name} when visibility restrictions for the organisation are enabled.',
        user_column: 'User',
        reason_column: 'Reason',
        groups_column: 'Group(s)',
        empty: 'No visibility users found for this investor.',
        load_error: 'Failed to load investor visibility.',
        adviser_filter_label: 'Filter by Adviser Firm',
        adviser_filter_all: 'All Adviser Firms'
    },
    users_visibility_panel: {
        heading: 'Visibility for {name}',
        heading_default: 'Visibility',
        description: 'Review visibility group coverage and effective investor visibility for {name}.',
        description_default: 'Review visibility group coverage and effective investor visibility.',
        load_error: 'Failed to load visibility groups for this user.',
        configure_cta: 'Configure visibility groups',
        contact_investors_list_title: 'Primary Contact Investors',
        granted_investors_list_title: 'Viewer Investors',
        effective_investors_list_title: 'Effective Investors',
        no_contact_investors: 'No Primary Contact investors found for this firm.',
        no_granted_investors: 'No Viewer investors found for this firm.',
        no_effective_investors: 'No effective investors found for this firm.',
        superuser_investor_count_tooltip:
            'As a Superuser, this user has visibility of all investors in the client list page.',
        more_investors: '+ {count} more...'
    }
};

export default page;
